<div (mouseleave)="closeActionPopUp()" class="actions-details" [hidden]="!displayActionPopUp"
    [ngStyle]="{'left': mouseClientX,'top': mouseClientY_Top,'bottom': mouseClientY_Bottom}" #outstandingPopup>
    <div class="inline-block float-right absolute-right">
        <button mat-icon-button (click)="closeActionPopUp()">
            <mat-icon aria-label="close">close</mat-icon>
        </button>
    </div>
    <table class="table">
        <thead>
            <tr>
                <th>{{Translate('Recommendation')}}</th>
                <th>{{Translate('Status')}}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let act of actionStatusTable">
                <td>{{Translate(act.ActionTitle)}}</td>
                <td><span [ngClass]="act.CssClass">{{Translate(act.ActionStatus)}}</span></td>
            </tr>
        </tbody>
    </table>
</div>
<div (mouseleave)="closetrackPopUp()" class="track-details" [hidden]="!displaytrackPopUp"
    [ngStyle]="{'left': mouseClientX,'top': mouseClientY_Top,'bottom': mouseClientY_Bottom}" #outstandingPopup_>
    <div class="inline-block float-right absolute-right">
        <button mat-icon-button (click)="closetrackPopUp()">
            <mat-icon aria-label="close">close</mat-icon>
        </button>
    </div>
    <table class="table">
        <thead>
            <tr>
                <th>{{Translate('Position')}}</th>
                <th>{{Translate('Type')}}</th>
                <th>{{Translate('Track Roller Values - ')}} {{Translate(side_eval) }}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let track of  trackPosition;  let i = index">
                <td>{{Translate(track.Position) }}</td>
                <td>{{Translate(track.Compart.CompartTitle) }}</td>
                <td class="component-span top {{getComponentTrackClass(track.Worn)}}">{{Translate(track.Worn) }}%</td>
            </tr>
        </tbody>
    </table>
</div>
<div class="panel__content no-padding fleet-overview-table">
    <div *ngIf="equipmentDataLoading || _loading != 0" [class.loading-initial]="equipmentDataLoading"
        [class.loading-next-page]="_loading != 0">
        <mat-spinner></mat-spinner>
    </div>
    <mat-table *ngIf="!equipmentDataLoading && _loading == 0 && enableTab"
        class="table-material table-material-scroll table-material--striped table-material--hover table-material--full-width"
        #componentTable [dataSource]="componentViewDataSource" matSort (matSortChange)="sortChanged($event)"
        [@fadeInOut] [matSortActive]="_currentSort.active" matSortDisableClear
        [matSortDirection]="_currentSort.direction">
        <ng-container matColumnDef="Serial">
            <mat-header-cell class="eval-header" mat-sort-header *matHeaderCellDef> {{Translate('Serial')}}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" matTooltip="{{row.Equipment.Serial}}">
                <div class="SerialAndUnitText">{{row.Equipment.Serial}}</div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Unit">
            <mat-header-cell class="eval-header" mat-sort-header *matHeaderCellDef> {{Translate('Unit')}}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" matTooltip="{{row.Equipment.Unit}}">
                <div class="SerialAndUnitText">{{row.Equipment.Unit}}</div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="AddiUnit">
            <mat-header-cell class="eval-header" mat-sort-header  *matHeaderCellDef> {{Translate('Additional Unit')}}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" matTooltip="{{row.Equipment.AdditUnit}}">
                <div class="SerialAndUnitText">{{row.Equipment.AddiUnit}}</div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Model">
            <mat-header-cell class="eval-header" mat-sort-header *matHeaderCellDef> {{Translate('Model')}}
            </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.Equipment.MakeModelFamily.Model.Title}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Site">
            <mat-header-cell class="eval-header" mat-sort-header *matHeaderCellDef> {{Translate('Site')}}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="cell--jobsite" matTooltip="{{row.Equipment.JobSite.Title}}">
                <div class="SerialAndUnitText"> {{row.Equipment.JobSite.Title}} </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="inspector">
            <mat-header-cell mat-sort-header *matHeaderCellDef>{{ Translate('Inspector')}}  </mat-header-cell>
            <mat-cell *matCellDef="let row"  matTooltip="{{row.LastInspection.Inspector}}">  <div class="InspectorName">{{row.LastInspection.Inspector}}</div> </mat-cell>
        </ng-container>
        <ng-container matColumnDef="CurrentSMU">
            <mat-header-cell class="eval-header" mat-sort-header *matHeaderCellDef>
                {{Translate('Current SMU/Hourmeter')}}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="text-center"> {{row.Equipment.SMU}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="sides">
            <mat-header-cell class="eval-header" *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <span class="component-span top {{getComponentClass(0,1, row.Components)}}">
                    {{Translate('Left')}}
                </span>
                <span class="component-span bottom {{getComponentClass(0,2, row.Components)}}">
                    {{Translate('Right')}}
                </span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Link">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Link')}} </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(1,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(1,1, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(1,1, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(1,1, row.Components)}}%
                        </div>
                    </span> -->

                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(1,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(1,2, row.Components,row)}}
                    </span>
                    <!-- <span class="component-span bottom {{getComponentClass(1,2, row.Components)}}">
                        {{getComponentValue(1,2, row.Components)}}%
                    </span> -->

                    <!-- <span>
                        <div class="component-span bottom {{getComponentClass(1,2, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference">   {{getComponentValue(1,2, row.Components)}}%
                        </div>
                    </span> -->
                </div>

            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="TrackElon">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Track Elongation')}} </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(16,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(16,1, row.Components,row)}}
                    </span>
                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(16,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(16,2, row.Components,row)}}
                    </span>
                </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Bush">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Bush')}} </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(3,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(3,1, row.Components,row)}}
                    </span>
                    <!-- <span class="component-span top {{getComponentClass(3,1, row.Components)}}">
                        {{getComponentValue(3,1, row.Components)}}%
                    </span> -->
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(3,1, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(3,1, row.Components)}}%
                        </div>
                    </span> -->
                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(3,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(3,2, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(3,2, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(3,2, row.Components)}}%
                        </div>
                    </span> -->
                </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="BushTurned">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Bush Turned')}} </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <span class="component-span top {{getComponentClass(4,1, row.Components)}}">
                    {{getComponentValue(4,1, row.Components,row)}}
                </span>
                <span class="component-span bottom {{getComponentClass(4,2, row.Components)}}">
                    {{getComponentValue(4,2, row.Components,row)}}
                </span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Shoe">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Shoe')}} </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(5,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(5,1, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(5,1, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(5,1, row.Components)}}%
                        </div>
                    </span> -->
                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(5,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(5,2, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(5,2, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(5,2, row.Components)}}%
                        </div>
                    </span> -->
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="FrontIdler">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Front Idler')}} </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(6,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(6,1, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(6,1, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(6,1, row.Components)}}%
                        </div>
                    </span> -->
                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(6,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(6,2, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(6,2, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(6,2, row.Components)}}%
                        </div>
                    </span> -->
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="RearIdler">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Rear Idler')}} </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(7,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(7,1, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(7,1, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(7,1, row.Components)}}%
                        </div>
                    </span> -->
                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(7,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(7,2, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(7,2, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(7,2, row.Components)}}%
                        </div>
                    </span> -->
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Sprocket">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Sprocket')}} </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(8,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(8,1, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(8,1, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(8,1, row.Components)}}%
                        </div>
                    </span> -->
                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(8,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(8,2, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(8,2, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(8,2, row.Components)}}%
                        </div>
                    </span> -->
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="CarrierRoller_1">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Carrier Roller')}} 1
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(9,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(9,1, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(9,1, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(9,1, row.Components)}}%
                        </div>
                    </span> -->
                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(9,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(9,2, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(9,2, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(9,2, row.Components)}}%
                        </div>
                    </span> -->
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="CarrierRoller_2">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Carrier Roller')}} 2
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(10,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(10,1, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(10,1, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(10,1, row.Components)}}%
                        </div>
                    </span> -->
                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(10,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(10,2, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(10,2, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(10,2, row.Components)}}%
                        </div>
                    </span> -->
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="CarrierRoller_3">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Carrier Roller')}} 3
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(11,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(11,1, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(11,1, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(11,1, row.Components)}}%
                        </div>
                    </span> -->
                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(11,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(11,2, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(11,2, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(11,2, row.Components)}}%
                        </div>
                    </span> -->
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="CarrierRoller_4">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Carrier Roller')}} 4
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(12,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(12,1, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(12,1, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(12,1, row.Components)}}%
                        </div>
                    </span> -->
                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(12,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(12,2, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(12,2, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(12,2, row.Components)}}%
                        </div>
                    </span> -->
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="CarrierRoller_5">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Carrier Roller')}} 5
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(13,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(13,1, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(13,1, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(13,1, row.Components)}}%
                        </div>
                    </span> -->
                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(13,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(13,2, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(13,2, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(13,2, row.Components)}}%
                        </div>
                    </span> -->
                </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="TrackRoller_1">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Track Roller')}} 1
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(14,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(14,1, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(14,1, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(14,1, row.Components)}}%
                        </div>
                    </span> -->
                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(14,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(14,2, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(14,2, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(14,2, row.Components)}}%
                        </div>
                    </span> -->
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="TrackRoller_2">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Track Roller')}} 2
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(15,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(15,1, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(15,1, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(15,1, row.Components)}}%
                        </div>
                    </span> -->
                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(15,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(15,2, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(15,2, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(15,2, row.Components)}}%
                        </div>
                    </span> -->
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="TrackRoller_3">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Track Roller')}} 3
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(16,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(16,1, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(16,1, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(16,1, row.Components)}}%
                        </div>
                    </span> -->
                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(16,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(16,2, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(16,2, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(16,2, row.Components)}}%
                        </div>
                    </span> -->
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="TrackRoller_4">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Track Roller')}} 4
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(17,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(17,1, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(17,1, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(17,1, row.Components)}}%
                        </div>
                    </span> -->
                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(17,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(17,2, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(17,2, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(17,2, row.Components)}}%
                        </div>
                    </span> -->
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="TrackRoller_5">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Track Roller')}} 5
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(18,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(18,1, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(18,1, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(18,1, row.Components)}}%
                        </div>
                    </span> -->
                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(18,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(18,2, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(18,2, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(18,2, row.Components)}}%
                        </div>
                    </span> -->
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="TrackRoller_6">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Track Roller')}} 6
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(19,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(19,1, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(19,1, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(19,1, row.Components)}}%
                        </div>
                    </span> -->
                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(19,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(19,2, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(19,2, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(19,2, row.Components)}}%
                        </div>
                    </span> -->
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="TrackRoller_7">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Track Roller')}} 7
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(20,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(20,1, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(20,1, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(20,1, row.Components)}}%
                        </div>
                    </span> -->
                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(20,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(20,2, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(20,2, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(20,2, row.Components)}}%
                        </div>
                    </span> -->
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="TrackRoller_8">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Track Roller')}} 8
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(21,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(21,1, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(21,1, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(21,1, row.Components)}}%
                        </div>
                    </span> -->
                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(21,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(21,2, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(21,2, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(21,2, row.Components)}}%
                        </div>
                    </span> -->
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="TrackRoller_9">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Track Roller')}} 9
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(22,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(22,1, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(22,1, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(22,1, row.Components)}}%
                        </div>
                    </span> -->
                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(22,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(22,2, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(22,2, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(22,2, row.Components)}}%
                        </div>
                    </span> -->
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="TrackRoller_10">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Track Roller')}} 10
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(23,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(23,1, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(23,1, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(23,1, row.Components)}}%
                        </div>
                    </span> -->
                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(23,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(23,2, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(23,2, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(23,2, row.Components)}}%
                        </div>
                    </span> -->
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="TrackRoller_11">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Track Roller')}} 11
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(24,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(24,1, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(24,1, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(24,1, row.Components)}}%
                        </div>
                    </span> -->
                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(24,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(24,2, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(24,2, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(24,2, row.Components)}}%
                        </div>
                    </span> -->
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="TrackRoller_12">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Track Roller')}} 12
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(25,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(25,1, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(25,1, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(25,1, row.Components)}}%
                        </div>
                    </span> -->
                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(25,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(25,2, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(25,2, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(25,2, row.Components)}}%
                        </div>
                    </span> -->
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="TrackRoller_13">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Track Roller')}} 13
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(26,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(26,1, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(26,1, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(26,1, row.Components)}}%
                        </div>
                    </span> -->
                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(26,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(26,2, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(26,2, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(26,2, row.Components)}}%
                        </div>
                    </span> -->
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="TrackRoller_14">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Track Roller')}} 14
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(27,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(27,1, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(27,1, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(27,1, row.Components)}}%
                        </div>
                    </span> -->
                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(27,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(27,2, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(27,2, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(27,2, row.Components)}}%
                        </div>
                    </span> -->
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="TrackRoller_15">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Track Roller')}} 15
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <div>
                    <span class="component-span top {{getComponentHoursClass(28,1, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(28,1, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(28,1, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(28,1, row.Components)}}%
                        </div>
                    </span> -->
                </div>
                <div>
                    <span class="component-span bottom {{getComponentHoursClass(28,2, row.Components)}}" title="Difference between budget life and projected life">
                        {{getComponentHours(28,2, row.Components,row)}}
                    </span>
                    <!-- <span>
                        <div class="component-span top {{getComponentClass(28,2, row.Components)}}" title=" %Difference = Projected Life 100% - Budget Life%
Difference calculated as 'Difference/Budget Life'
Colour scheme depends on the % Difference"> {{getComponentValue(28,2, row.Components)}}%
                        </div>
                    </span> -->
                </div>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="componentDisplayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: componentDisplayedColumns;" class="hand-pointer expand-on-hover"
            (click)="rowClicked(row)"></mat-row>
    </mat-table>
    <mat-paginator [hidden]="!(!equipmentDataLoading && _loading == 0 && enableTab)" #componentPaginator [pageSize]="loadSize"
        [pageSizeOptions]="[5, 10, 25, 100]" (page)="componentPageChanged($event)">
    </mat-paginator>
</div>
